import React from 'react'
import {getLogger} from '../../services/logging'
import {GuestInfo} from '../../schema'

const logger = getLogger('CheckoutGuestInfoDisplay')

export interface CheckoutGuestInfoDisplayProps {
  guestInfo: GuestInfo
  onEdit: () => void
}

const CheckoutGuestInfoDisplay = ({
  guestInfo,
  onEdit
}: CheckoutGuestInfoDisplayProps) => {
  return (
    <div className="flex flex-row gap-1 my-4">
      <div className="flex-1 flex flex-col gap-2">
        <div className="flex flex-col">
          <span className="text-xs font-semibold">Name:</span>
          <span className="text-sm">
            {guestInfo.firstName} {guestInfo.lastName}
          </span>
        </div>

        <div className="flex flex-col">
          <span className="text-xs font-semibold">Email:</span>
          <span className="text-sm">{guestInfo.email}</span>
        </div>

        <div className="flex flex-col">
          <span className="text-xs font-semibold">Phone:</span>
          <span className="text-sm">
            {guestInfo.formattedPhone || guestInfo.phone}
          </span>
        </div>

        {guestInfo.comments && (
          <div className="flex flex-col">
            <span className="text-xs font-semibold">Comments:</span>
            <p className="text-sm">{guestInfo.comments}</p>
          </div>
        )}
      </div>
      <div className="flex-0">
        <button
          className="btn btn-sm btn-primary btn-outline"
          onClick={() => {
            logger.info({message: 'User clicked on edit guest info'})
            if (onEdit) {
              onEdit()
            }
          }}
          aria-label="Edit guest information."
        >
          Edit
        </button>
      </div>
    </div>
  )
}

export default CheckoutGuestInfoDisplay
